import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/home.vue')
  },
  {
	path: '/about',
	name: 'about',
	component: () => import('../views/about/about.vue')
  },
  {
	path: '/charity',
	name: 'charity',
	component: () => import('../views/charity/charity.vue')  
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/help/help.vue')
  },
  {
    path: '/questionDetail',
    name: 'questionDetail',
    component: () => import('../views/help/questionDetail.vue')
  },
  {
    path: '/legal',
    name: 'legal',
    component: () => import('../views/legal/legal.vue')
  },
  {
    path: '/legalDetail',
    name: 'legalDetail',
    component: () => import('../views/legal/legalDetail.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router